import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Activiteit } from '../types/Activiteit'

export { patchActiviteitForEntity }

const patchActiviteitForEntity = async ({
  entity: { type, id },
  activiteitInfo: { _id, dueDate, text },
}: {
  entity: Entity
  activiteitInfo: Pick<Activiteit, '_id' | 'dueDate' | 'text'>
}) => {
  await apiClient({
    url: `/rest/${type}/${id}/activiteit/${_id}`,
    method: 'PATCH',
    data: { dueDate, text },
  })
}
